exports.inject = function(module) {
  module.factory('ConferenceCalls', ['$resource', exports.factory]);
};

exports.factory = function($resource) {
  return $resource('/bridges/api/v1/set-caller-name/:conferenceCallId/?format=json', { conferenceCallId: '@conferenceCallId' }, {
    changeCall: {
      method: 'POST',
      headers : {"Content-Type": "application/x-www-form-urlencoded"},
      params: { conferenceCallId: '@conferenceCallId' },
      transformRequest: function(data) {
        return $.param(data);
      }
    },
    query: {
      method: 'GET',
      isArray: false
    }
  });
};



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/conferencecall-service.js
 ** module id = 234
 ** module chunks = 0
 **/